import React from "react";
import { generalIcons } from "../../utils/constants";
import { SubPageSectionHeading } from "../../components";

const TextData = [
  {
    id: 1,
    icon: generalIcons.step1,
    detail: "Choose the cryptocurrency to bridge (e.g., ETH, USDT).",
  },
  {
    id: 2,
    icon: generalIcons.step2,
    detail: "Specify the destination network (Vanar Chain).",
  },
  {
    id: 3,
    icon: generalIcons.step3,
    detail:
      "Complete the transaction and receive $VANRY on the Vanar blockchain.",
  },
];

const BridgeProcess = () => {
  return (
    <section className="relative py-6 lg:py-12">
      <div className="w-full flex justify-center  max-w-[858px] mx-auto text-center">
        <SubPageSectionHeading className="mb-4 lg:mb-8">
          Bridge process overview
        </SubPageSectionHeading>
      </div>

      <div className="grid lg:grid-cols-3 gap-4 laptop:gap-7">
        {TextData.map((item, index) => (
          <div
            key={index}
            className=" justify-center w-full gap-3 md:gap-4 relative p-6 lg:p-8 lg:min-h-[236px] bg-white hoverCardTop group hover:!bg-[#1B2129]  hover:!text-white  h-full flex flex-col  gap-5w-full duration-300  bg-CardBG bg-no-repeat bg-cover bg-right-bottom before:absolute before:bg-contain hover:before:bg-[#1B2129]/80 before:bg-no-repeat before:bg-right-bottom before:bg-yellowDotBg before:bottom-0 before:h-full before:right-0 before:w-full before:z-[-1]"
          >
            {/* <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>
            <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div> */}
            <span className="size-8 lg:size-12 flex items-center justify-center *:w-full *:h-full duration-300">
              {item.icon}
            </span>
            <div className="space-y-3">
              <h3
                style={{
                  fontSize: "clamp(1.125rem, 1.075rem + 0.25vw, 1.375rem)",
                  lineHeight: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                }}
                className="font-bold uppercase font-sans tracking-[-1.2px] text-gunMetal group-hover:text-white duration-200"
              >
                Step 0{item.id}
              </h3>
              <p className="text-gunMetal text-[12px]/[16px] lg:text-[16px]/[24px] font-medium font-serif group-hover:text-white duration-200 min-h-[50px]">
                {item.detail}
              </p>
            </div>
          </div>
        ))}
        {/* <div className="col-span-1">
          <div className="flex flex-col justify-start items-start w-full gap-3 md:gap-5 text-left benefitcard relative lg:px-[20px] py-[15px] lg:min-h-[236px] bg-white hoverCardTop p-6 lg:p-8 group duration-300 hover:bg-primaryGd overflow-hidden h-full">
            <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>
            <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>
            <span className="size-12 flex items-center justify-center *:w-full *:h-full   duration-300">
              {generalIcons.step1}
            </span>
            <div className="space-y-3">
              <h3
                style={{
                  fontSize: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                  lineHeight: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                }}
                className="font-bold uppercase font-sans tracking-[-1.2px] text-gunMetal group-hover:text-white"
              >
                Step 01
              </h3>
              <p className="text-gunMetal text-[12px]/[16px] lg:text-[16px]/[24px] font-medium font-serif group-hover:text-white">
                Choose the cryptocurrency to bridge (e.g., ETH, USDT).
              </p>
            </div>
          </div>
        </div>

        <div className="col-span-1">
          <div className="flex flex-col justify-start items-start w-full gap-3 md:gap-5 text-left benefitcard relative lg:px-[20px] py-[15px] lg:min-h-[236px] bg-white hoverCardTop p-6 lg:p-8 group duration-300 hover:bg-primaryGd overflow-hidden h-full">
            <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>

            <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>
            <span className="!size-12   flex items-center justify-center *:w-full *:h-full   duration-300">
              {generalIcons.step2}
            </span>
            <div className="space-y-3">
              <h3
                style={{
                  fontSize: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                  lineHeight: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                }}
                className="font-bold uppercase font-sans tracking-[-1.2px] text-gunMetal group-hover:text-white"
              >
                Step 02
              </h3>
              <p className="text-gunMetal text-[12px]/[16px] lg:text-[16px]/[24px] font-medium font-serif group-hover:text-white">
                Specify the destination network (Vanar Chain).
              </p>
            </div>
          </div>
        </div>
        <div className="col-span-1">
          <div className="flex flex-col justify-start items-start w-full gap-3 md:gap-5 text-left benefitcard relative lg:px-[20px] py-[15px] lg:min-h-[236px] bg-white hoverCardTop p-6 lg:p-8 group duration-300 hover:bg-primaryGd overflow-hidden h-full">
            <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>
            <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div>
            <span className="!size-12   flex items-center justify-center *:w-full *:h-full   duration-300">
              {generalIcons.step3}
            </span>
            <div className="space-y-3">
              <h3
                style={{
                  fontSize: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                  lineHeight: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                }}
                className="font-bold uppercase font-sans tracking-[-1.2px] text-gunMetal group-hover:text-white"
              >
                Step 03
              </h3>
              <p className="text-gunMetal text-[12px]/[16px] lg:text-[16px]/[24px] font-medium font-serif group-hover:text-white">
                Complete the transaction and receive $VANRY on the Vanar
                blockchain.
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default BridgeProcess;
